import React from "react";
import { useStyles } from "../styles/styles";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// DesktopDatePicker, not the responsive DatePicker: the responsive variant
// switches on `@media (pointer: fine)`, so touch devices get MobileDatePicker,
// which forces the input read-only and removes the calendar button. That leaves
// no way to type a date of birth on a phone and contradicts the MM/DD/YYYY
// instructions we give the user (WCAG 3.3.2). Pinning the desktop variant keeps
// typed entry and the calendar button on every device.
import { DesktopDatePicker } from "@mui/x-date-pickers";
import Box from '@mui/material/Box';

const Dob = (props) => {
    const dob = props.dob;
    const setDob = props.setDob;
    const required = props.required;
    const errorId = props.errorId;
    const classes = useStyles;

    const descriptionId = "dob-dialog-desc";
    const helperId = "dob-format-helper";

    // No autofocus on mount. This field sits mid-form everywhere it is used --
    // 9th control in the RockVy traffic school form, and below the name fields
    // in LookupForm -- so focusing it on mount dropped keyboard and screen
    // reader users into the middle of a form they had not seen the top of
    // (WCAG 2.4.3). The aria-describedby wiring below announces the field's
    // context on focus without having to take focus to do it.

    return (
        <>
            <FormControl fullWidth sx={classes.formControl}>
                <FormLabel required={required} sx={classes.inputLabel} htmlFor='dob'>
                    {/* lineHeight 1 keeps this smaller inline span from growing the
                        label's line box to 24px, which pushed the whole field a
                        pixel below its neighbours. */}
                    Date of Birth <span style={{ fontSize: '0.85em', fontWeight: 'normal', lineHeight: 1 }}>(MM/DD/YYYY)</span>
                </FormLabel>
                <Box sx={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}>
                    <span id={descriptionId}>
                        Select your date of birth. Month, day, and year are required.
                    </span>
                    <span id={helperId}>
                        Format: MM/DD/YYYY
                    </span>
                </Box>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                        name='dob'
                        disableFuture={true}
                        // A date of birth is decades back; opening on the day
                        // view at the current month makes the calendar a long
                        // walk for switch and magnifier users.
                        openTo='year'
                        defaultValue={null}
                        value={dob}
                        onChange={(newValue) => {
                            setDob(newValue)
                        }}
                        slotProps={{
                            // v6 emits no aria-haspopup, so the trigger does not
                            // announce that it opens a dialog.
                            openPickerButton: {
                                "aria-haspopup": "dialog"
                            },
                            textField: {
                                id: 'dob',

                                // Without fullWidth the outlined input keeps its intrinsic
                                // ~20ch width, so at a 320px viewport it overflows the grid
                                // column and the trailing calendar button is clipped off.
                                fullWidth: true,

                                placeholder: "MM/DD/YYYY",

                                sx: {
                                    '& input::placeholder': {
                                        color: '#767676',
                                        opacity: 1
                                    }
                                },

                                slotProps: {
                                    htmlInput: {
                                        sx: classes.textbox,
                                        "aria-label": "Date of birth, MM/DD/YYYY",
                                        "aria-describedby": `${descriptionId} ${helperId}${errorId ? ` ${errorId}` : ''}`,
                                        "aria-required": "true",
                                        "aria-invalid": errorId ? "true" : "false"
                                    },
                                },
                            }
                        }}
                    />
                </LocalizationProvider>
            </FormControl>
        </>
    );
};

export default Dob;
